/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {ThemeColorPath} from 'platform/foundation';

/** The square before each tile's label — the tile's only colour, one per measure. */
export const SALES_LEAGUE_KPI_VEHICLES_COLOR: ThemeColorPath = 'palettes.blue.60.100';
export const SALES_LEAGUE_KPI_TOTAL_MARGIN_COLOR: ThemeColorPath = 'palettes.green.60.100';
export const SALES_LEAGUE_KPI_AVG_MARGIN_COLOR: ThemeColorPath = 'palettes.purple.60.100';
export const SALES_LEAGUE_KPI_BEST_MARGIN_COLOR: ThemeColorPath = 'palettes.orange.60.100';
